import { useEffect, useState } from 'react';
import { breakpoints } from '../../styles';
import throttle from 'lodash.throttle';
export function useBreakpoints(throttleDelay = 100) {
    const [matchingBreakpoints, setMatchingBreakpoints] = useState([
        'xs'
    ]);
    //xs | sm | md | lg | xl
    const breakpointKeys = Object.keys(breakpoints);
    useEffect(() => {
        const resize = throttle(() => {
            setMatchingBreakpoints(breakpointKeys.filter((breakpoint) => typeof window.matchMedia == 'function' &&
                window.matchMedia(`(min-width: ${breakpoints[breakpoint]}px)`)
                    .matches));
        }, throttleDelay);
        resize();
        window.addEventListener('resize', resize);
        return () => {
            window.removeEventListener('resize', resize);
        };
    }, [throttleDelay]);
    return matchingBreakpoints;
}
//# sourceMappingURL=use-breakpoints.js.map